<template>
  <modal-structure
    :affirmative-handler="handleAffirmative"
  >
    <template v-slot:header />
    <template v-slot:content>
      <h1>You have entered information into the form, leaving this page would result in these changes being lost. Are you sure you want to navigate away?</h1>
    </template>
    <template v-slot:footer />
  </modal-structure>
</template>

<script>
import ModalStructure from './ModalStructure'
import { mapActions } from 'vuex'
export default {

  name: 'ConfirmNavigation',
  components: {
    ModalStructure
  },

  methods: {
    ...mapActions(['setPageNavRequiresConfirmation']),
    handleAffirmative () {
      this.setPageNavRequiresConfirmation(false)
      this.$router.push(this.$router.history.pending.fullPath)
    }
  }
}
</script>

<style lang="scss" scoped>
  h1 {
    text-align: left;
  }
</style>
